import { useEffect, useState } from "react";

import _ from "lodash";

import { FormFieldBackground } from "components/Forms/Form";
import InputMultipleDate from "components/Input/InputMultipleDate/InputMultipleDate";
import InputMultipleSelect from "components/Input/InputMultipleSelect";
import InputText, {
  INPUT_TEXT_TYPE,
} from "components/Input/InputText/InputText";
import InputTime from "components/Input/InputTime";
import { useTranslations } from "hooks";
import { IOption } from "model/application/components";
import { TViewMode } from "model/application/modal/CreateEditModal";
import { IClient } from "model/entities/Client";

import { getWeeksOptions } from "./utils";

interface IGpsTrackingSectionProps extends Partial<IClient> {
  viewMode?: TViewMode;
  onInputChange: (value: any, name: string) => void;
  onChangeGpsTrackingDays?: (optSelected: IOption[], name: string) => void;
  getFieldError?: (key: string) => string | undefined;
}

const GpsTrackingSection = ({
  viewMode = "CREATE",
  onInputChange,
  getFieldError,
  geo_checkin_distance,
  geo_checkout_distance,
  time_slots_start,
  time_slots_stop,
  id: clientId,
  timezone,
  working_days,
  holidays,
}: IGpsTrackingSectionProps) => {
  const lang = useTranslations();
  const label = lang.containers.clients.subCategories.clients.createEditModal;
  const allDaysOptions = getWeeksOptions(lang);

  const [currentWorkingDays, setCurrentWorkingDays] = useState<IOption[]>([]);

  useEffect(() => {
    const newWorkingDays = _.filter(allDaysOptions, (day) =>
      _.includes(working_days, day.value),
    );
    setCurrentWorkingDays(newWorkingDays);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectWorkingDays = (optSelected: IOption[]) => {
    const allOptionsSelected = _.filter(allDaysOptions, (day) =>
      _.includes(_.map(optSelected, "key"), day.key),
    );
    const selectedDays = _.map(allOptionsSelected, "value");
    setCurrentWorkingDays(optSelected);
    onInputChange(selectedDays, "working_days");
  };

  return (
    <div>
      <FormFieldBackground viewMode={viewMode}>
        <InputText
          defaultValue={geo_checkin_distance}
          error={getFieldError?.("geo_checkin_distance")}
          name="geo_checkin_distance"
          key={`geo_checkin_distance${clientId}`}
          lang={label.inputGeoCheckinDistance}
          onChange={onInputChange}
          required={true}
          type={INPUT_TEXT_TYPE.INTEGER}
          viewMode={viewMode}
          debounceDuration={400}
        />
      </FormFieldBackground>

      <InputText
        defaultValue={geo_checkout_distance}
        error={getFieldError?.("geo_checkout_distance")}
        name="geo_checkout_distance"
        key={`geo_checkout_distance${clientId}`}
        lang={label.inputGeoCheckOutDistance}
        onChange={onInputChange}
        required={true}
        type={INPUT_TEXT_TYPE.INTEGER}
        viewMode={viewMode}
        debounceDuration={400}
      />

      <FormFieldBackground viewMode={viewMode}>
        <InputMultipleSelect
          viewMode={viewMode}
          name="working_days"
          options={allDaysOptions}
          defaultValue={currentWorkingDays}
          onChange={onSelectWorkingDays}
          multipleSelection
          langlabel={label.inputTrackingDays}
          lang={lang}
        />
      </FormFieldBackground>

      <InputMultipleDate
        name="holidays"
        langlabel={label.inputHolidays}
        defaultValues={holidays ?? []}
        onChange={onInputChange}
        viewMode={viewMode}
        returnFormatted
        format="yyyy-MM-dd"
      />

      <FormFieldBackground viewMode={viewMode}>
        <InputTime
          key={timezone}
          viewMode={viewMode}
          defaultValue={time_slots_start}
          name="time_slots_start"
          lang={label.inputTimeSlotsStart}
          onChange={onInputChange}
          required={false}
          clearable
        />
      </FormFieldBackground>

      <InputTime
        key={timezone}
        viewMode={viewMode}
        defaultValue={time_slots_stop}
        name="time_slots_stop"
        lang={label.inputTimeSlotsStop}
        onChange={onInputChange}
        required={false}
        clearable
      />
    </div>
  );
};

export default GpsTrackingSection;
